import { useContext, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthContext from '../../context/autenticacion/authContext';

const RutaPrivada = ({ component: Component, ...props  }) => {

    const authContext = useContext(AuthContext);
    const { Movimientos, autenticado, Saldos, usuarioAutenticado, userStatus,ListaNacionales, ListaInternacionales, ListaRemesas,TodosRetiros, TodosDepositos,TodosOfertas,TodosOferentes, TodosInversiones,TodosInversionesVendidas,TodosProyectosSecundario,
        TodosProyectosPrimario, PantherLoadAppRecarga, PantherLoad } = authContext;

    useEffect(() => {
        PantherLoadAppRecarga();
        PantherLoad();

        // Antes salían ~17 peticiones a la vez; el hosting rechazaba conexiones a MySQL.
        // Ahora: primero lo esencial, y el resto de a 2. No se cancela al desmontar:
        // el Login espera a que lleguen movimientos y proyectos para entrar.
        const esenciales = [userStatus, usuarioAutenticado, Saldos, Movimientos];
        const resto = [
            ListaNacionales, ListaInternacionales, ListaRemesas,
            TodosRetiros, TodosDepositos, TodosOfertas, TodosOferentes,
            TodosInversiones, TodosInversionesVendidas,
            TodosProyectosSecundario, TodosProyectosPrimario
        ];
        const lote = (fns) => Promise.allSettled(fns.map((fn) => fn()));

        (async () => {
            await lote(esenciales.slice(0, 2));
            await lote(esenciales.slice(2));
            for (let i = 0; i < resto.length; i += 2) {
                    await lote(resto.slice(i, i + 2));
            }
        })();

        // eslint-disable-next-line
    }, []);

    return ( 
        <Route { ...props } render={ props => !autenticado ?  (
            <Redirect to="/" />
        )  : (
            <Component {...props} />
        ) } />

     );
}
 
export default RutaPrivada;